import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 12l10 0","key":"svg-0"}],["path",{"d":"M10 12l4 -4","key":"svg-1"}],["path",{"d":"M10 12l4 4","key":"svg-2"}],["path",{"d":"M4 20l0 -3m0 -13l0 3m0 3.5l0 3","key":"svg-3"}]]

const IconArrowBarToLeftDashed = createReactComponent('outline', 'arrow-bar-to-left-dashed', 'ArrowBarToLeftDashed', __iconNode);

export default IconArrowBarToLeftDashed;